export const getFaturamentos = (state) => state.faturamento.lista
export const getTotalFaturamentos = (state) => state.faturamento.total
export const getIsCarregandoListaFaturamentos = (state) => state.faturamento.isCarregandoLista
export const getFaturamentoSelecionado = (state) => state.faturamento.selecionado
export const getIsCarregandoFaturamento = (state) => state.faturamento.isCarregandoFaturamento
export const getIsSavingFaturamento = (state) => state.faturamento.isSaving
